import React from 'react'
import ArticlePreview from './ArticlePreview'

const BlogList = ({ posts }) => (
	<ul className="carousel gap-6">
		{posts?.map((post, key) => (
			<li key={key}>
				<ArticlePreview post={post} index={key} />
			</li>
		))}
	</ul>
)

export default BlogList
